import React, { useState, useContext, useEffect, useRef } from 'react';
import './Defrost.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import TimelineText from '@/v2/components/atoms/TimelineText';
import TimeController from '@/v2/components/controllers/TimeController';
import Button from '@/v2/components/atoms/Button';
import Fade from '@/v2/components/atoms/Fade';
import { AnalyticsContext } from '@/v2/components/application/Analytics';
import Header from '@/v2/components/application/Header';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { ConnectivityContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';
import { ClearMemory } from '@/v2/components/utils/DeviceUtils';
import { timeout, saveTimeout, clearTimeouts } from '@/v2/components/utils/Timeout';

let videoController = null;
let timeController = null;

const STATE = {
    intro: 'intro',
    warmup: 'warmup',
    cta: 'cta',
};

const videoReady = (controller, onReady) => {
    videoController = controller;
    onReady();
};

const play = (timeline) => {
    videoController.Play();
    timeController.AddTimeoutFromTimeline(timeline, () => {});
};

const activate = (setTime, setState, timeline) => {
    timeController = new TimeController(setTime);
    saveTimeout(
        timeController.AddTimeoutFromTimeline(timeline, () => {
            setState(STATE.warmup);
        })
    );
};

export default ({ isActive, data, onFinished, onReady }) => {
    const [state, setState] = useState(STATE.intro);
    const [animate, setAnimateState] = useState(['in', 'in']);
    const [showFade, setShowFade] = useState(false);
    const { trackEvent } = useContext(AnalyticsContext);
    const [{ disclaimer }] = useContext(ConnectivityContext);
    const { dispatch: momentDispatch } = useContext(MomentStateContext);

    const time = useRef(TimelineText.Time());

    useEffect(() => () => clearTimeouts(), []);

    useEffect(() => {
        if (isActive) {
            activate(time.current.Set, setState, data.text.timeline);
        }
    }, [isActive]);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
        }
    }, [isActive, videoController]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, onReady),
        autoPlay: false,
        onFinished: () => {
            setState(STATE.cta);
        },
    };

    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} dark /> : '';
    const timeline = state === STATE.intro ? data.text.timeline : data.text.secondaryTimeline;
    return (
        <div className="Defrost">
            <VideoSimple src={data.video} offsetRatio={1.9} offset={75} options={options} />
            <TimelineText data={timeline} time={time.current} background="light" color="black" key={`timeline-${state}`} />
            <Header show={isActive} hideLogo dark />
            {state === STATE.warmup && (
                <div className="Defrost__cta">
                    <Button
                        variant="base"
                        animate={animate[0]}
                        onClick={() => {
                            setAnimateState(['out', 'in']);
                            play(timeline);
                            trackEvent('vcClick', {
                                vcStep: 'defrost',
                                vcClick: 'button:warmup',
                            });
                        }}
                    >
                        {data.text.cta.warmup}
                    </Button>
                </div>
            )}
            {state === STATE.cta && (
                <div className="Defrost__cta">
                    <Button
                        variant="base"
                        animate={animate[1]}
                        onClick={() => {
                            setAnimateState(['out', 'out']);
                            setShowFade(true);
                            trackEvent('vcClick', {
                                vcStep: 'defrost',
                                vcClick: "button:let's drive",
                            });
                            timeout(() => {
                                onFinished();
                                ClearMemory();
                            }, 1000);
                        }}
                    >
                        {data.text.cta.board}
                    </Button>
                </div>
            )}
            {disclaimerContent}

            <Fade show={showFade} light cover disableFadeOut />
        </div>
    );
};
